module.exports = __webpack_public_path__ + "components/rewards/offline-maps/static/logo-891799fb109f85b647f9c7e031e8bdf2.webp";